<template>
	<div
		class="flex flex-col items-start self-stretch gap-3 p-5 border rounded-lg border-grey-950 bg-grey-950"
		data-test="alignment-card"
	>
		<div class="flex flex-col w-full gap-3 sm:flex-row sm:items-center sm:gap-8">
			<div class="flex flex-col flex-1 min-w-0 gap-3">
				<h3
					class="mb-0 text-xl font-semibold text-white"
					data-test="alignment-card-title"
				>
					{{ title }}
				</h3>
				<p
					class="mb-0 text-base text-grey-400"
					data-test="alignment-card-description"
				>
					{{ description }}
				</p>
			</div>

			<div
				class="hidden h-10 border-l border-grey-900 sm:block"
				aria-hidden="true"
			/>

			<div
				class="flex items-end justify-between shrink-0 sm:flex-col sm:justify-center"
			>
				<span
					class="text-sm uppercase font-heading text-grey-400 font-extrabold"
					data-test="alignment-card-label"
				>
					{{ $t('general.work-style') }}
				</span>
				<span
					class="font-heading text-[32px] font-extrabold text-white"
					data-test="alignment-card-score"
				>
					{{ roundedScore }}%
				</span>
			</div>
		</div>
	</div>
</template>

<script>
import { getAlignmentBand } from '~/components/Personality/utils/personalityInsights'

export default {
	name: 'OverviewAlignmentCard',
	props: {
		score: {
			type: Number,
			default: 0
		},
		side: {
			type: String,
			default: 'company',
			validator: value => ['company', 'applicant'].includes(value)
		},
		summary: {
			type: String,
			default: ''
		}
	},
	computed: {
		roundedScore() {
			return Math.round(this.score)
		},
		band() {
			return getAlignmentBand(this.score)
		},
		title() {
			return this.$t(
				`personality_results.alignment_card.title.${this.side}.${this.band}`
			)
		},
		description() {
			// AI summary when present; static band copy is the fallback.
			return (
				this.summary ||
				this.$t(
					`personality_results.alignment_card.description.${this.side}.${this.band}`
				)
			)
		}
	}
}
</script>
